import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import "./Strength.css";

export const inspirationalQuote =
  "Each call you take is an opportunity to shine. Your strengths continue to guide you toward excellence.";

const Strength = () => {
  const performanceData = useSelector(
    (state) => state?.agentHome?.performanceData
  );

  /* -------- FORMAT DATA INTO ROWS -------- */
  const strengthList = useMemo(() => {
    const msg = performanceData?.strengthMessage?.myStrength;

    if (!msg) return [];

    return msg
      .replace(/^\[|\]$/g, "") // remove []
      .split('","') // split items
      .map((item) => item.replace(/^"|"$/g, "").trim())
      .filter(Boolean);
  }, [performanceData]);

  return (
    <div className="strength-container">
      <div className="strength-content">
        <div className="strength-card">
          {/* HEADER ROW */}
          {/* DATA ROWS */}
          <div className="strength-table-body">
            {strengthList.length > 0 ? (
              strengthList.map((item, index) => (
                <div className="strength-row" key={index}>
                  <span className="strength-col-number">
                    {(index + 1).toString().padStart(2, "0")}
                  </span>

                  <span className="strength-col-text">{item}</span>
                </div>
              ))
            ) : (
              <div className="strength-empty">
                No strength insights available.
              </div>
            )}
          </div>
        </div>

        <blockquote className="strength-quote">
          "{inspirationalQuote}"
        </blockquote>
      </div>
    </div>
  );
};

export default Strength;